module.exports = __webpack_public_path__ + "files/01f1d5bf121e2ba8371e66aa2215bd99.png";